import { NavPills } from '@hyperflake/react-ui-library';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

const NotificationLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const navItems = [
        {
            content: 'Client Level',
            href: `/push-notification`,
            isActive: pathname === `/push-notification`,
        },
        {
            content: 'User Level',
            href: `/push-notification/clients`,
            isActive: pathname.startsWith(`/push-notification/clients`),
        },
        {
            content: 'History',
            href: `/push-notification/notification-list`,
            isActive: pathname.startsWith(`/push-notification/notification-list`),
        },
    ];

    return (
        <PageTemplate>
            <div className="min-h-screen">
                <div className="p-3">
                    <div className="flex justify-between">
                        <PageHeading>Push Notification</PageHeading>
                    </div>
                    <div className="mt-4 overflow-x-auto no-scrollbar -mx-3 px-3 lg:overflow-visible lg:mx-0 lg:px-0 snap-x snap-mandatory">
                        <NavPills
                            className="whitespace-nowrap inline-flex gap-2 snap-x"
                            items={navItems.map((item) => ({
                                content: (
                                    <Link to={item.href} className="snap-start">
                                        {item.content}
                                    </Link>
                                ),
                                isActive: item.isActive,
                                onClick: () => navigate(item.href),
                            }))}
                        />
                    </div>
                    <Outlet />
                </div>
            </div>
        </PageTemplate>
    );
};

export default NotificationLayout;
